/* Events Issue View will trigger for ecosystem add-on */
export const ISSUE_QUICK_ADD_CLICKED = 'ISSUE_QUICK_ADD_CLICKED';

export const ISSUE_GLANCE_OPENED = 'ISSUE_GLANCE_OPENED';

export const ISSUE_GLANCE_CONTENT_CLICKED = 'ISSUE_GLANCE_CONTENT_CLICKED';
